const RowRepeaterComponent = {
    templateUrl: '/formViewer/component/rowRepeater/rowRepeater.tpl.html',
    controller: 'rowRepeaterController',
    bindings: {
        row: '<',
        rootFormId: '<',
        configurable: '<'
    }
};

angular.module('umFormViewer')
    .component('uiRowRepeater', RowRepeaterComponent);
